import React, {useState} from "react";
import ReactApexChart from "react-apexcharts";

import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";
 import {coverColor} from "../../helpers/api_helper"

const Basic = ({series,leftText,bottomText,maxXaxis,dataColors}) => {

    let maxValue;
    for(let i = 0; i < series.length; i++){
        maxValue = parseInt(series[i]['data'][0][0]);
    }    

    var chartScatterBasicColors = getChartColorsArray(dataColors);    
    const options = {
        chart: {
            zoom: {
                enabled: true,
                type: "xy",
            },
            toolbar: {
                show: true,
            },
        },
        xaxis: {
            tickAmount: 3,
            min: 0,
            max:maxValue+50/5,
            title: {
                text: bottomText??"Quantity Sold",                
                style:{
                    colors:['#000000']
                }
            },
        },
        yaxis: {
            title: {
                text: leftText,
                style: {
                    fontWeight: 600,
                },
            },
            tickAmount: 10
        },
        colors: coverColor,
        legend:{
            height:80,
            showForSingleSeries: true,
        }
    };
    return (
        <React.Fragment>
            <ReactApexChart
                options={options}
                series={series}
                type="scatter"
                height={500}
            />
        </React.Fragment>
    );
};

const Datetime = ({series,dataColors}) => {
    var chartScatterDateTimeColors = getChartColorsArray(dataColors);

    const options = {
        chart: {
            zoom: {
                type: "xy",
            },
            toolbar: {
                show: !1,
            },
        },
        dataLabels: {
            enabled: !1,
        },
        grid: {
            xaxis: {
                lines: {
                    show: !0,
                },
            },
            yaxis: {
                lines: {
                    show: !0,
                },
            },
        },
        xaxis: {
            type: "datetime",
        },
        yaxis: {
            max: 100,
        },
        colors: chartScatterDateTimeColors,
    };

    return (
        <React.Fragment>
            <ReactApexChart
                options={options}
                series={series}
                type="scatter"
                height={350}
            />
        </React.Fragment>
    );
};

export {
    Basic,
    Datetime
};
